import { useState } from 'react'
import { WriteForUsForm } from './write-for-us-form'
import { AuthUser } from 'app/provider/auth'
import { useCreateContentWriterRequest } from './commands'

export interface WriteForUsFormContainerProps {
  user: Pick<AuthUser, 'id' | 'email' | 'fullName'>
}

export const WriteForUsFormContainer = (props: WriteForUsFormContainerProps) => {
  const [submitted, setSubmitted] = useState(false)
  const [createContentWriterRequest, { loading }] = useCreateContentWriterRequest()

  const handleSubmit = async (message) => {
    await createContentWriterRequest({
      variables: {
        name: props.user.fullName,
        email: props.user.email,
        message,
      },
      onCompleted: () => {
        setSubmitted(true)
      },
      onError: (err) => {
        console.error('Error submitting form', err)
        setSubmitted(true)
      }
    });
  }

  return <WriteForUsForm submitting={loading} submitted={submitted} onSubmit={handleSubmit} />
}
